import { render, staticRenderFns } from "./MoverService.vue?vue&type=template&id=21dc5134&"
import script from "./MoverService.vue?vue&type=script&lang=js&"
export * from "./MoverService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports